import React from "react";
import PropTypes from "prop-types";

import styles from "./BrandedDeepDiveHeader.css";

export default function BrandedDeepDiveHeader(props) {
  return (
    <div className={styles.root}>
      <h2 className={styles.subheader}>
        <em>{props.sponsor}</em>
      </h2>
      <h1 className={styles.header}>{props.title}</h1>
      <p className={styles.text}>{props.subtitle}</p>
    </div>
  );
}

BrandedDeepDiveHeader.propTypes = {
  sponsor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
